<template>
    <div class="">
        <div class="page-info-wrapper">

            <div class="page-info-content">
                <div class="page-info-content-company">
                    <!--<img v-if="companyDetail.companyLogo!=''" :src="companyDetail.companyLogo" alt="" class="company-logo">
                    <img v-else src="../assets/img/gongsi.png" alt="" class="company-logo">-->

                    <div v-if="userInfo.role != 0" class="page-info-refresh">
                        <el-dropdown @command="handleDropdown">
                            <div class="el-dropdown-link compony-dropdown">
                                <slot></slot>
                                <!-- <div class="page-info-refresh-label">切换企业</div> -->
                            </div>
                            <el-dropdown-menu slot="dropdown" class="company-dropdown-wrap">
                                <el-dropdown-item v-for="(item, key) in companyData" :key="'dropdown-' + key"
                                    :command="item">
                                    <el-radio v-model="item.check" :label="item.deptId">
                                        {{ item.companyName }}
                                    </el-radio>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import { userCompanyInfo, getAllCompany, getCompanyDetail, switchCompanyChange } from '@/api/index.js';
export default {
    name: '',
    props: {
        mode: {
            type: String
        }
    },
    components: {

    },
    data() {
        return {
            dept: "",
            token: "",
            activeCompany: {},
            companyData: [],
            companyDetail: {},
            userInfo: {},
        }
    },
    created() {

        // if (this.$route.params.dept) {
        //     this.dept = this.$route.params.dept;
        // } else {
        //     this.dept = localStorage.getItem('dept') ? localStorage.getItem('dept') : '';
        // }
        // if (this.$route.params.token) {
        //     this.token = this.$route.params.token;
        // } else {
        //     console.log('从本地获取的token')
        //     this.token = localStorage.getItem('token') ? localStorage.getItem('token') : "";
        // }




        // if (this.dept) {
        //     window.localStorage.setItem('dept', this.dept);
        // }
        // if (this.token) {
        //     window.localStorage.setItem('token', this.token);
        // }
        this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');
        this.getTodept();

    },
    mounted() {

    },
    methods: {
        getTodept() {
            // console.log('333333333333333333333333333333333getTodept')
            userCompanyInfo({}, { Authorization: this.token, }).then(res => {

                if (res.code == 200) {

                    var data = res.data;
                    this.dept = data.deptId;
                    localStorage.setItem('dept', data.deptId);
                    localStorage.setItem('TopDeptId', data.topDeptId);
                    this.getCompanyData();
                }

            })
        },
        // 判断设备企业微信
        isWorkWechat() {
            //获取user-agaent标识头
            var ua = window.navigator.userAgent.toLowerCase();
            //判断ua和微信浏览器的标识头是否匹配
            if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
                return true;
            } else {
                return false;
            }
        },
        getCompanyData() {
            var token = window.localStorage.getItem("token");
            //   var token= this.$route.params.token;
            if (!this.isWorkWechat() || this.isWorkWechat() && token) {


                getAllCompany({}, {
                    Authorization: this.token,
                    DeptId: this.dept,

                }).then(res => {
                    if (res.code == 200) {

                        var data = res.data;
                        var _this = this;
                        var arr = [];
                        for (var i = 0; i < data.length; i++) {
                            var item = data[i];
                            item["check"] = "";
                            arr.push(item);
                            if (i == arr.length - 1) {
                                this.companyData = arr;
                                window.localStorage.setItem("activeCompany", JSON.stringify(arr[0]));
                                //  this.companyDetailInfo();
                                var row = JSON.parse(window.localStorage.getItem('activeCompany'));
                                if (!row) {
                                    row = this.companyData[0];
                                    window.localStorage.setItem("activeCompany", JSON.stringify(row));
                                }
                                this.setCompany(row);
                            }
                        }
                    }
                    return;
                }).catch(err => {
                    // console.log(err);
                });
            }
        },
        handleDropdown(row) {
            // console.log(row, "(((((((((((())))))))))))", this.companyData)
            var target = row.deptId;
            var companyData = this.companyData;
            for (var i = 0; i < companyData.length; i++) {
                var item = companyData[i];
                if (item.deptId == target) {
                    this.companyData[i]["check"] = target;
                } else {
                    this.companyData[i]["check"] = '';
                }
            }
            this.switchCompanyChange(row.deptId)
            this.changeCompany(row);
        },
        changeCompany(row) {
            window.localStorage.setItem("activeCompany", JSON.stringify(row));
            var host = window.location.host;
            var port = window.location.port;
            if (port && port != '') {
                port = ':' + port;
            }
            var newDomain = row.domain;
            var hash = '/' + window.location.hash;
            // var newURL = newDomain + port + '/#/index/enterprise-center/' + row.deptId + '/' + this.token;
            //修改跳转带token
            var newURL = newDomain + port + "/#/index?idName=enterprise-center&deptId=" + row.deptId + "&token=" + this.token
            if (this.isWorkWechat()) {
                window.localStorage.clear();
            }
            console.log(newURL)
            window.location.href = newURL;
        },
        setCompany(row) {
            var data = this.companyData;
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                if (item.deptId == Number(row.deptId)) {
                    this.companyData[i]["check"] = Number(item.deptId);
                } else {
                    this.companyData[i]["check"] = "";
                }
            }
        },
        companyDetailInfo() {
            // console.log('333333333333333333333333333333333getCompanyDetail')
            var row = JSON.parse(window.localStorage.getItem('activeCompany'));
            if (!row) {
                row = this.companyData[0];
                window.localStorage.setItem("activeCompany", JSON.stringify(row));
            }
            this.setCompany(row);
            getCompanyDetail({}, {
                Authorization: this.token,
                DeptId: this.dept,
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.companyDetail = data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        switchCompanyChange(deptId) {
            switchCompanyChange({
                deptId,
                clientType: 3
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
    }
}
</script>

<style scoped>
.page-info-wrapper {
    width: 100%;





}

.page-info-image-wrapper {
    width: 133px;
    margin-left: 45px;
    margin-top: 76px;
}

.page-info-image {
    width: 133px;
    height: 69px;
}

.page-info-content {

    flex: 1;
    height: 100%;
}

.company-logo {
    width: 150px;
    height: 100px;
}

.page-info-content-company {
    display: flex;
}

.page-info-content-company2 {
    display: flex;
    height: 100%;
    align-items: center;
}

.page-info-content-company-name {
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    display: flex;
    align-items: center;
}

.page-info-refresh {

    cursor: pointer;
}

.company-dropdown-wrap {
    max-height: 170px;
    overflow-y: scroll;
    width: 350px;
    text-overflow: ellipsis;
}

.compony-dropdown {
    width: 102px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.page-info-set {
    width: 76px;
    height: 26px;
    display: flex;
    margin-left: 21px;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 26px;
    margin-top: 5px;
    cursor: pointer;
    line-height: 26px;
    position: relative;
}

.page-info-shape-wrapper {
    width: 102px;
    height: 26px;
    position: absolute;
    top: 0px;
    left: 0px;
}

.page-info-set-img-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
}

.rect-image {
    width: 100%;
    height: 100%;
}

.page-info-set-wrapper {
    position: relative;
    top: 2px;
}

.info-set-img {
    width: 14px;
    height: 14px;
}

.image {
    width: 100%;
    height: 100%;
}

.branch-image {
    width: 14px;
    height: 12px;
}

.page-info-team {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;
    margin-top: 24px;
}

.page-info-refresh-label {
    margin-left: 6px;
}

.page-info-set-label {
    margin-left: 6px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #CCCCCC;
}

.page-info-reset-label {
    margin-left: 6px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F6986D;
}

.page-author-wrapper {
    position: absolute;
    right: 32px;
    top: 71px;
}

.page-author-item {
    display: flex;
    line-height: 30px;
    height: 30px;
    align-items: center;
}

.page-author-icon {
    width: 16px;
    height: 18px;
}

.page-author-label {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-left: 6px;
}
</style>


